export default "__VITE_ASSET__WJMwJrh2__"